<template>
  <router-link :to="post.path">
    <div class="card">
      <div class="card-image">
        <figure class="image">
          <img :src="thumb" alt="">
        </figure>
      </div>
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <p class="title is-5">{{post.title.rendered | truncate('22','...') }}</p>
          </div>
        </div>
        <div class="content">
          <time :datetime="post.date | dateformat">{{post.date | dateformat}}</time>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
  // let base_path = process.env.VUE_APP_MATERIAL_URL_BASE;
  // console.log(process.env.VUE_APP_MATERIAL_URL_BASE);
  // console.log(this.post.slug);

  export default {
    props: ["post"],
    data() {
      return {
        'thumb': this.getThumb()
      };
    },
    watch: {
      post() {
        this.thumb = this.getThumb();
      },
      current() {}
    },

    computed: {},
    mounted() {
      // console.log("material",this.post);
    },
    methods: {
      getThumb() {
        if(this.post.children.length){
          let child = this.post.children[0];
          return this.getMaterialUrl(child.slug + '.svg');
        }else{
          return this.getMaterialUrl(this.post.slug + '.svg');
        }
      }
    },

    components: {}
  };
</script>